import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="7 7 10 10" {...props}>
      <title>{props.title || 'Pause'}</title>
      <g>
        <path d="M17 7.5v9c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5zM11 7.5v9c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5z" />
      </g>
    </Icon>
  )
}
